// 函数创建一个空的菜单数据
export function initialPB() {
    return {
        chagreeid: '',
        tempid: '',
        isauto: '0',
        remark: '',
        id: '',
    }
}